import { render, staticRenderFns } from "./DesktopMainEvents.vue?vue&type=template&id=500cb1e8"
import script from "./DesktopMainEvents.vue?vue&type=script&lang=js"
export * from "./DesktopMainEvents.vue?vue&type=script&lang=js"
import style0 from "./DesktopMainEvents.vue?vue&type=style&index=0&id=500cb1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports